module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "channels__container"
  }, [_c('h2', {
    staticClass: "ui inverted center aligned header"
  }, [_vm._v("Channels "), _c('i', {
    staticClass: "add square icon add_channel",
    on: {
      "click": _vm.openChannelModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui raised channels__list"
  }, [_c('ul', _vm._l((_vm.channels), function(channel) {
    return _c('li', {
      key: channel.id,
      staticClass: "channels__item",
      class: {
        'is_active': _vm.setChannelActive(channel)
      },
      on: {
        "click": function($event) {
          _vm.changeChannel(channel)
        }
      }
    }, [_vm._v("\n                   # " + _vm._s(channel.name) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "channelModal"
    }
  }, [_c('div', {
    staticClass: "ui icon header"
  }, [_vm._v("\n               Add Channel\n           ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui inverted form",
    class: {
      'error': _vm.hasErrors
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "new_channel"
    }
  }, [_vm._v("Name for Channel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_channel),
      expression: "new_channel"
    }],
    attrs: {
      "type": "text",
      "name": "new_channel",
      "id": "new_channel"
    },
    domProps: {
      "value": (_vm.new_channel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_channel = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "ui error message"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui green inverted button",
    on: {
      "click": _vm.addChannel
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Add\n               ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Not add\n               ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78927086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/Channels.vue
// module id = 227
// module chunks = 1